import React, { useEffect, useState, useMemo, useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { toast } from 'react-toastify';

import {
  ExpansionPanel,
  ExpansionPanelSummary,
  ExpansionPanelDetails,
  Typography,
} from '@material-ui/core';
import { Form } from '@unform/web';
import { isArray, isNaN, isNull, includes, isUndefined } from 'lodash';
import PropTypes from 'prop-types';
import * as Yup from 'yup';

import { Spinner, SelectDataInTable } from '~/components';
import {
  Select,
  Input,
  Checkbox,
  ComboboxMultiple,
  Autocomplete,
  CheckboxGroup,
  Hidden,
} from '~/components/Form';
import {
  CONTRATO_ABASTECIMENTO,
  CENTRO_CUSTO_ABASTECIMENTO,
  CONTROLE_DE_COTAS,
  LUBRIFICACAO,
  SAP,
  CUSTOMIZACAO_TEREOS,
  MODULO_CONSULTA_TOTALIZADOR,
  CUSTOMIZACAO_RAIZEN,
  MODULO_AFERICAO_DVEC,
} from '~/constants/modules';
import { t, can, validCharacters } from '~/helpers';
import api from '~/services/api';
import { storeVeiculo, updateVeiculo } from '~/store/modules/veiculo/actions';

import { Container } from './styles';

export default function CreateOrUpdate({
  reference,
  data,
  create,
  toggleLoading,
  toggleConfirmButton,
}) {
  const dispatch = useDispatch();

  const { modules } = useSelector((state) => state.user);
  const { client } = useSelector((state) => state.user.profile);
  const {
    formadigitacaofrota,
    exibebloqtngveicclienteconfig,
    exibebloqueiadigitatotalizadordvecclienteconfig,
  } = useSelector((state) => state.user.configs);
  const { loading, find, params } = useSelector((state) => state.veiculo);

  const [leituraC, setLeituraC] = useState(false);
  const [leDEVEC, setLeDEVEC] = useState(false);
  const [bloqueiaTotDEVEC, setBloqueiaTotDEVEC] = useState(false);
  const [snPDVEC, setSnPDVEC] = useState(false);
  const [snPTTAG, setPTTAG] = useState(false);
  const [snLCONT, setLCONT] = useState(false);
  const [snDFTV, setDFTV] = useState(false);

  const [valorPossuidvecveiculo, setValorPossuidvecveiculo] = useState(0);
  const [valorIddvecveiculo, setValorIddvecveiculo] = useState('');

  const [custo, setCusto] = useState(null);
  const [compartments, setCompartments] = useState([]);
  const [dataCompartments, setDataCompartments] = useState([]);
  const [postosVeiculo, setPostosVeiculo] = useState([]);

  const initials = create
    ? {
      bloqueiaabastacimatanqueveiculo: 'S',
      tipototalizadorveiculo: '0',
      tipototalizador2veiculo: '0',
      ...data,
    }
    : { ...find, ...data };

  // console.log(JSON.stringify(initials));

  // const isEdit = !!initials?.id;
  const isEdit = Boolean(initials && initials.id);

  const [tipoTotalizador, setTipoTotalizador] = useState(
    isEdit ? initials?.tipototalizadorveiculo ?? 0 : 0
  );
  const [tipoTotalizador2, setTipoTotalizador2] = useState(
    isEdit ? initials?.tipototalizador2veiculo ?? 0 : 0
  );

  const [maxtagveiculomodelo, setMaxTagVeiculoModelo] = useState(undefined);
  const [maxtagveiculomodeloLista, setmaxtagveiculomodeloLista] = useState([]);

  const [snIdModeloVeiculo, setSnIdModeloVeiculo] = useState(null);
  const [pendingRequests, setPendingRequests] = useState(0);
  const [hasLoadingError, setHasLoadingError] = useState(false);
  const loadingErrorMessage =
    's.geral.loadingerror';

  const handleAsyncLoadingChange = useCallback((isLoading) => {
    setPendingRequests((state) => {
      if (hasLoadingError) return 0;

      if (isLoading) return state + 1;

      return state > 0 ? state - 1 : 0;
    });
  }, [hasLoadingError]);

  const handleAsyncLoadingError = useCallback(() => {
    setHasLoadingError(true);
    setPendingRequests(0);
  }, []);

  useEffect(() => {
    toggleLoading(pendingRequests > 0);
  }, [pendingRequests, toggleLoading]);

  useEffect(() => {
    toggleConfirmButton(!hasLoadingError);
  }, [hasLoadingError, toggleConfirmButton]);

  useEffect(
    () => () => {
      toggleLoading(false);
      toggleConfirmButton(true);
    },
    [toggleLoading, toggleConfirmButton]
  );

  useEffect(() => {
    if (isEdit) {
      setTipoTotalizador(initials?.tipototalizadorveiculo ?? 0);
      setTipoTotalizador2(initials?.tipototalizador2veiculo ?? 0);
    }
  }, [initials, isEdit]);

  const totalizador = useMemo(
    () => [
      { value: 0, label: 'Não Possui' },
      { value: 1, label: t('s.operacao.abastecimento.horimetro') },
      { value: 2, label: t('s.operacao.abastecimento.hodometro') },
    ],
    []
  );

  const totalizadorDigitosTotalizadorVeiculo = useMemo(
    () => [
      { value: 5, label: '5' },
      { value: 6, label: '6' },
      { value: 7, label: '7' },
      { value: 8, label: '8' },
      { value: 9, label: '9' },
    ],
    []
  );

  const totalizadorCasasDecimaisTotalizadorVeiculo = useMemo(
    () => [
      { value: 0, label: '0' },
      { value: 1, label: '1' },
    ],
    []
  );

  const status = useMemo(
    () => [
      { value: 'N', label: t('s.geral.opcoes.nao') },
      { value: 'S', label: t('s.geral.opcoes.sim') },
    ],
    []
  );

  const tipomovimentaosap = useMemo(
    () => [
      { value: 201, label: t('s.cadastro.modeloveiculo.sap.201') },
      { value: 221, label: t('s.cadastro.modeloveiculo.sap.221') },
      { value: 261, label: t('s.cadastro.modeloveiculo.sap.261') },
      { value: 281, label: t('s.cadastro.modeloveiculo.sap.281') },
    ],
    []
  );

  const isFields = useMemo(
    () => [
      {
        id: 'idcompartimento',
        label: t('s.cadastro.modeloveiculo.idcompartimento'),
        type: 'number',
        disabled: true,
      },
      {
        id: 'descricaocompartimento',
        label: t('s.cadastro.modeloveiculo.descricaocompartimento'),
        type: 'text',
        disabled: true,
      },
      {
        id: 'possuittagveiculocompartimento',
        label: t('s.cadastro.veiculo.possuittagveiculo'),
        type: 'select',
        options: status,
      },
      {
        id: 'leituracontinuattagveiculocompartimento',
        label: t('s.cadastro.veiculo.leituracontinuattagveiculo'),
        type: 'select',
        options: status,
      },
      {
        id: 'transponderveiculotransponder',
        label: t('s.operacao.limpezatag.taghistoricotag'),
        type: 'text',
        disabled: true,
      },
    ],
    [status]
  );

  const schemaValidate = useMemo(
    () => ({
      possuittagveiculocompartimento: Yup.string()
        .nullable()
        .required(t('s.geral.validacao.campoobrigatorio')),
      leituracontinuattagveiculocompartimento: Yup.string().required(
        t('s.geral.validacao.campoobrigatorio')
      ),
    }),
    []
  );

  const cellsCompartiments = useMemo(
    () => [
      {
        id: 'idcompartimento',
        label: t('s.cadastro.modeloveiculo.idcompartimento'),
      },
      {
        id: 'descricaocompartimento',
        label: t('s.cadastro.modeloveiculo.descricaocompartimento'),
      },
      {
        id: 'nomeabreviadoproduto',
        label: t('s.geral.camposistema.nomeproduto'),
      },
      {
        id: 'possuittagveiculocompartimento',
        label: t('s.cadastro.veiculo.possuittagveiculo'),
        format: (value) =>
          t(`s.geral.opcoes.${value && value === 'S' ? 'sim' : 'nao'}`),
      },
      {
        id: 'leituracontinuattagveiculocompartimento',
        label: t('s.cadastro.veiculo.leituracontinuattagveiculo'),
        format: (value) =>
          t(`s.geral.opcoes.${value && value === 'S' ? 'sim' : 'nao'}`),
      },
      {
        id: 'transponderveiculotransponder',
        label: t('s.operacao.limpezatag.taghistoricotag'),
      },
    ],
    []
  );

  async function handleValidateCenterCost() {
    await api
      .get(`centroscustos/${custo}`, { params: { pesquisalista: true } })
      .catch(async () => {
        await reference.current.setFieldValue('idcentrocusto', null);
        await setCusto(null);

        reference.current.setFieldError(
          'idcentrocusto',
          'Centro de Custo não encontrado!'
        );
      });
  }

  async function handleSubmit(param) {
    try {
      if (hasLoadingError) {
        toast.error(t(loadingErrorMessage));
        return;
      }

      if (pendingRequests > 0) {
        toast.warning(
          t('s.geral.validacao.aguardecarregamento')
        );
        return;
      }

      const customTereos = includes(modules, CUSTOMIZACAO_TEREOS);

      const schema = Yup.object().shape({
        idveiculo: create
          ? Yup.string()
            .required(t('s.geral.validacao.campoobrigatorio'))
            .max(10, t('s.geral.validacao.tamanhomaximo').replace('%s', 10))
            .test(
              'characters-invalid',
              t('s.configuracao.geral.naopodecontercaracterespecial'),
              (value) => validCharacters(value)
            )
          : Yup.string(),
        idempresaveiculo: create
          ? Yup.string()
            .required(t('s.geral.validacao.campoobrigatorio'))
            .nullable()
            .max(10, t('s.geral.validacao.tamanhomaximo').replace('%s', 10))
            .test(
              'characters-invalid',
              t('s.configuracao.geral.naopodecontercaracterespecial'),
              (value) => validCharacters(value)
            )
          : Yup.string(),
        idcentrocusto:
          can(CENTRO_CUSTO_ABASTECIMENTO) && !can(SAP)
            ? Yup.string()
              .nullable()
              .required(t('s.geral.validacao.campoobrigatorio'))
              .test(
                'characters-invalid',
                t('s.configuracao.geral.naopodecontercaracterespecial'),
                (value) => validCharacters(value)
              )
            : Yup.string().nullable(),
        placaveiculo: Yup.string()
          .required(t('s.geral.validacao.campoobrigatorio'))
          .max(10, t('s.geral.validacao.tamanhomaximo').replace('%s', 10))
          .test(
            'characters-invalid',
            t('s.configuracao.geral.naopodecontercaracterespecial'),
            (value) => validCharacters(value)
          ),
        idmodeloveiculo: Yup.string()
          .nullable()
          .required(t('s.geral.validacao.campoobrigatorio')),
        tipoveiculo: Yup.string().required(
          t('s.geral.validacao.campoobrigatorio')
        ),
        statusveiculo: Yup.string().required(
          t('s.geral.validacao.campoobrigatorio')
        ),
        volumetanqueveiculo: Yup.number()
          .required(t('s.geral.validacao.campoobrigatorio'))
          .transform((value) => (isNaN(value) ? undefined : value))
          .integer(t('s.geral.validacao.deveserinteiro'))
          .min(0, t('s.geral.validacao.valorminimo').replace('%s', 0))
          .lessThan(
            50001,
            t('s.geral.validacao.valormaximo').replace('%s', 50000)
          ),
        rodagemminimaveiculo: Yup.number()
          .required(t('s.geral.validacao.campoobrigatorio'))
          .transform((value) => (isNaN(value) ? undefined : value))
          .integer(t('s.geral.validacao.deveserinteiro'))
          .min(0, t('s.geral.validacao.valorminimo').replace('%s', 0))
          .lessThan(
            10000,
            t('s.geral.validacao.valormaximo').replace('%s', 10000)
          ),
        rodagemmaximaveiculo: Yup.number()
          .required(t('s.geral.validacao.campoobrigatorio'))
          .transform((value) => (isNaN(value) ? undefined : value))
          .integer(t('s.geral.validacao.deveserinteiro'))
          .min(0, t('s.geral.validacao.valorminimo').replace('%s', 0))
          .lessThan(
            10000,
            t('s.geral.validacao.valormaximo').replace('%s', 10000)
          ),
        tipototalizadorveiculo: Yup.string().required(
          t('s.geral.validacao.campoobrigatorio')
        ),
        digitostotalizadorveiculo:
          tipoTotalizador != 0
            ? Yup.number().required(t('s.geral.validacao.campoobrigatorio'))
            : Yup.number().nullable(),
        casasdecimaistotalizadorveiculo:
          tipoTotalizador != 0
            ? Yup.number().required(t('s.geral.validacao.campoobrigatorio'))
            : Yup.number().nullable(),
        tipototalizador2veiculo:
          tipoTotalizador != 0
            ? Yup.string().required(t('s.geral.validacao.campoobrigatorio'))
            : Yup.string().nullable(),
        digitostotalizador2veiculo:
          tipoTotalizador2 != 0
            ? Yup.number().required(t('s.geral.validacao.campoobrigatorio'))
            : Yup.number().nullable(),
        casasdecimaistotalizador2veiculo:
          tipoTotalizador2 != 0
            ? Yup.number().required(t('s.geral.validacao.campoobrigatorio'))
            : Yup.number().nullable(),
        aceitatotforafaixa: Yup.string().required(
          t('s.geral.validacao.campoobrigatorio')
        ),
        observacaoveiculo: Yup.string()
          .nullable()
          .max(255, t('s.geral.validacao.tamanhomaximo').replace('%s', 255)),
        idpostoproprietario: customTereos
          ? Yup.string()
            .typeError(t('s.geral.validacao.campoobrigatorio'))
            .required(t('s.geral.validacao.campoobrigatorio'))
          : Yup.string().nullable(),
        idpostogestor: customTereos
          ? Yup.string()
            .typeError(t('s.geral.validacao.campoobrigatorio'))
            .required(t('s.geral.validacao.campoobrigatorio'))
          : Yup.string().nullable(),
        bloqueiaabastacimatanqueveiculo: customTereos
          ? Yup.string()
            .typeError(t('s.geral.validacao.campoobrigatorio'))
            .required(t('s.geral.validacao.campoobrigatorio'))
          : Yup.string().nullable(),
        iddvecveiculo: Yup.string()
          .nullable()
          .typeError('Erro')
          .max(20, t('s.geral.validacao.tamanhomaximo').replace('%s', '20')),
        possuidvecveiculo: can(MODULO_CONSULTA_TOTALIZADOR)
          ? Yup.string()
            .required(t('s.geral.validacao.campoobrigatorio'))
            .typeError(t('s.geral.validacao.campoobrigatorio'))
          : Yup.string().nullable(),
        // Não prescisa!!!  bloqueiadigitatotalizadordevecveiculo
        // bloqueiadigitatotalizadordevecveiculo: !can(MODULO_CONSULTA_TOTALIZADOR)
        //   ? Yup.string()
        //     .required(t('s.geral.validacao.campoobrigatorio'))
        //     .typeError(t('s.geral.validacao.campoobrigatorio'))
        //   : Yup.string().nullable(),
      });

      await schema.validate(param, {
        abortEarly: false,
      });

      const serializer = (value) => {
        if (can(MODULO_CONSULTA_TOTALIZADOR)) {
          return value;
        }

        return value ? '1' : '0';
      };

      const objSend = {
        idveiculo: '',
        totalizadorveiculo: 0,
        totalizador2veiculo: 0,
        statusdbic4veiculo: 1,
        transponders: [],
        cota: {
          controlacotaveiculocota: 'N',
          volumeveiculocota: 0,
          saldoveiculocota: 0.0,
          anomesveiculocota: '',
        },
        sap: {
          movimentoveiculosap: 201,
          sigordemveiculosap: null,
          elementopepveiculosap: null,
          contarazaoveiculosap: null,
          diagramaredeveiculosap: null,
          reservaveiculosap: null,
          equiptosapveiculosap: null,
          frotasapveiculosap: null,
          operacaoveiculosap: null,
        },
        ...initials,
        ...param,
        digitostotalizadorveiculo:
          param.totalizadorveiculo === 0 ? 0 : param.digitostotalizadorveiculo,
        casasdecimaistotalizadorveiculo:
          param.totalizadorveiculo === 0
            ? 0
            : param.casasdecimaistotalizadorveiculo,

        digitostotalizador2veiculo:
          isNull(param.totalizador2veiculo) || param.totalizador2veiculo === 0
            ? 0
            : param.digitostotalizador2veiculo,
        casasdecimaistotalizador2veiculo:
          isNull(param.totalizador2veiculo) || param.totalizador2veiculo === 0
            ? 0
            : param.casasdecimaistotalizador2veiculo,

        possuidvecveiculo: serializer(param.possuidvecveiculo),
        tipodvecveiculo: 0,
        possuittagveiculo: snPTTAG ? 'S' : 'N',

        bloqueiadigitatotalizadordevecveiculo:
          isUndefined(param.possuidvecveiculo) ||
            isNull(param.possuidvecveiculo) ||
            param.possuidvecveiculo === false
            ? 'N'
            : bloqueiaTotDEVEC
              ? 'S'
              : 'N',

        digitafrotaterminalveiculo: snDFTV ? 1 : 0,
        idcliente: client,
        veiculocompartimento: create
          ? compartments.map((c) => ({ ...c, idveiculo: param.idveiculo }))
          : compartments,
        postos: postosVeiculo,
        leituracontinuattagveiculo: param.leituracontinuattagveiculo || 0,
      };

      if (create) {
        dispatch(storeVeiculo(objSend, params));
      } else {
        dispatch(updateVeiculo(objSend, params));
      }
    } catch (err) {
      const validationErrors = {};

      if (err instanceof Yup.ValidationError) {
        err.inner.forEach((error) => {
          validationErrors[error.path] = error.message.replace(
            `${error.path} `,
            ''
          );
        });

        reference.current.setErrors(validationErrors);
      }
    }
  }

  const handleGetCompartiments = useCallback(
    async (id) => {
      if (can(LUBRIFICACAO)) {
        try {
          handleAsyncLoadingChange(true);
          if (isNull(id)) {
            setDataCompartments([]);
          } else {
            const response = await api.get(`veiculoscompartimentos/${id}`, {
              params: { pagesize: 99999, pesquisalista: true },
            });

            setDataCompartments(response.data);
          }
        } catch (err) {
          handleAsyncLoadingError();
          if (isArray(err)) err.map((e) => toast.error(t(e)));
          else toast(t(err));
        } finally {
          handleAsyncLoadingChange(false);
        }
      }
    },
    [handleAsyncLoadingChange, handleAsyncLoadingError]
  );

  function handleMaxTagVeiculoArray(quantTag) {
    const tagsLocal = [];
    if (quantTag) {
      for (let i = 0; i < quantTag; i++) {
        if (i === 0) {
          const item = {
            label: 'Não Definido',
            value: 0,
          };
          tagsLocal.push(item);
        } else {
          const item = {
            label: String(i),
            value: i,
          };
          tagsLocal.push(item);
        }
      }
    }
    setmaxtagveiculomodeloLista(tagsLocal);
  }

  async function handleModeloVeiculo(value) {
    await handleGetCompartiments(value.idmodeloveiculo);
    await setMaxTagVeiculoModelo(value.maxtagveiculomodelo);
    await handleMaxTagVeiculoArray(value.maxtagveiculomodelo);
    await setSnIdModeloVeiculo(value.idmodeloveiculo);
  }

  useEffect(() => {
    // const obj = {...find};
    // if (obj) {
    //   console.log('obj')
    //   console.log(JSON.stringify(obj))
    // }

    const {
      iddvecveiculo,
      possuidvecveiculo,

      possuittagveiculo,
      leituracontinuattagveiculo,
      veiculocompartimento,
      digitafrotaterminalveiculo,
      postos,
    } = find;

    if (possuidvecveiculo) {
      setValorPossuidvecveiculo(possuidvecveiculo);
    } else {
      setValorPossuidvecveiculo(0);
    }

    if (iddvecveiculo) {
      setValorIddvecveiculo(iddvecveiculo);
    } else {
      setValorIddvecveiculo('');
    }

    if (possuittagveiculo && possuittagveiculo === 'S') {
      setPTTAG(true);
      setLeituraC(true);
    }

    if (possuittagveiculo && possuittagveiculo === 'S') {
      setPTTAG(true);
    }

    if (leituracontinuattagveiculo && leituracontinuattagveiculo === 'S') {
      setLCONT(leituracontinuattagveiculo);
    }

    if (veiculocompartimento) {
      setCompartments(veiculocompartimento);
    }

    if (postos) {
      setPostosVeiculo(postos);
    }

    if (digitafrotaterminalveiculo) {
      setDFTV(true);
    }
  }, [find]);

  const disablePossuiDvecPrenchidoEdit = React.useMemo(() => {
    let status = true;
    if (can(MODULO_CONSULTA_TOTALIZADOR)) {
      console.log(valorPossuidvecveiculo);
      console.log(valorIddvecveiculo);

      switch (Number(valorPossuidvecveiculo)) {
        case 0:
          status = false;
          console.log('Número é 0');
          break;
        case 1:
          console.log('Número é 1');
          if (!valorIddvecveiculo) {
            status = false;
          } else {
            status = true;
          }
          break;
        case 2:
          console.log('Número é 2');
          if (!valorIddvecveiculo) {
            status = false;
          } else {
            status = true;
          }
          break;
        case 3:
          console.log('Número é 3');
          if (!valorIddvecveiculo) {
            status = false;
          } else {
            status = true;
          }
          break;
        case 4:
          if (!valorIddvecveiculo) {
            status = false;
          } else {
            status = true;
          }
          break;
        default:
          status = false;
      }
    } else {
      status = true;
      if (!valorIddvecveiculo) {
        status = false;
      } else {
        status = true;
      }
      console.log('Sei não');
    }
    return status;
  }, [MODULO_CONSULTA_TOTALIZADOR, valorPossuidvecveiculo, valorIddvecveiculo]);

  return (
    <>
      {loading ? (
        <div style={{ height: '14rem', width: '50rem' }}>
          <Spinner loading />
        </div>
      ) : hasLoadingError ? (
        <div
          style={{
            border: '1px solid #f5c6cb',
            background: '#f8d7da',
            color: '#721c24',
            borderRadius: '4px',
            padding: '16px',
            lineHeight: 1.5,
          }}
        >
          {t(loadingErrorMessage)}
        </div>
      ) : (
        <Form ref={reference} initialData={initials} onSubmit={handleSubmit}>
          <ExpansionPanel expanded>
            <ExpansionPanelSummary
              aria-controls="panel1a-content"
              id="panel1a-header"
              style={{
                background: 'rgba(0, 0, 0, 0.05)',
                borderBottom: '1px solid rgba(0,0,0,.2)',
              }}
            >
              <Typography>
                {t('s.cadastro.veiculo.informacoesveiculo')}
              </Typography>
            </ExpansionPanelSummary>
            <ExpansionPanelDetails>
              <Container>
                <Input
                  name="idveiculo"
                  label={t('s.cadastro.veiculo.idveiculo')}
                  disabled={!create}
                />

                <Autocomplete
                  name="idempresaveiculo"
                  label={
                    can(CUSTOMIZACAO_RAIZEN)
                      ? 'idempresaveiculo'
                      : 'nomeempresaveiculo'
                  }
                  url="empresasveiculos"
                  unique="idempresaveiculo"
                  title={t('s.cadastro.veiculo.idempresaveiculo')}
                  disabled={can(CUSTOMIZACAO_RAIZEN)}
                  onLoadingChange={handleAsyncLoadingChange}
                  onLoadingError={handleAsyncLoadingError}
                />

                {can(CENTRO_CUSTO_ABASTECIMENTO) && (
                  <Autocomplete
                    name="idcentrocusto"
                    label="nomecentrocustostr"
                    unique="idcentrocusto"
                    title={t('s.cadastro.veiculo.idcentrocusto')}
                    url="centroscustos"
                    onLoadingChange={handleAsyncLoadingChange}
                    onLoadingError={handleAsyncLoadingError}
                  />
                )}

                <Input
                  name="placaveiculo"
                  label={t('s.cadastro.veiculo.placaveiculo')}
                  disabled={can(CUSTOMIZACAO_RAIZEN)}
                />

                {includes(modules, CUSTOMIZACAO_TEREOS) && (
                  <>
                    <Autocomplete
                      name="idpostoproprietario"
                      label="nomeposto"
                      unique="idposto"
                      title={t('s.cadastro.veiculo.postoproprietario')}
                      url="postos"
                      onLoadingChange={handleAsyncLoadingChange}
                      onLoadingError={handleAsyncLoadingError}
                    />

                    <Autocomplete
                      name="idpostogestor"
                      label="nomeposto"
                      unique="idposto"
                      title={t('s.cadastro.veiculo.postogestor')}
                      url="postos"
                      onLoadingChange={handleAsyncLoadingChange}
                      onLoadingError={handleAsyncLoadingError}
                    />
                  </>
                )}

                <Autocomplete
                  name="idmodeloveiculo"
                  title={t('s.cadastro.veiculo.idmodeloveiculo')}
                  label="nomemodelomarcamodeloveiculo"
                  unique="idmodeloveiculo"
                  url="modelosveiculos"
                  params={{
                    fieldlist:
                      'idmodeloveiculo,nomemodelomarcamodeloveiculo,maxtagveiculomodelo',
                    orderfield: 'nomemodelomarcamodeloveiculo',
                    wherefield: ['tipomodeloveiculo'],
                    valuewherefield: ['V'],
                    typewherefield: ['EQUALS'],
                  }}
                  getValue={(value) => {
                    handleModeloVeiculo(value);
                  }}
                  disabled={can(CUSTOMIZACAO_RAIZEN)}
                  onLoadingChange={handleAsyncLoadingChange}
                  onLoadingError={handleAsyncLoadingError}
                />

                {/* <Select
                  name="maxtagveiculoAux"
                  label={t('s.cadastro.veiculo.maxtagveiculo')}
                  options={maxtagveiculomodeloLista}
                /> */}

                {snIdModeloVeiculo !== null && (
                  <Autocomplete
                    name="maxtagveiculo"
                    title={t('s.cadastro.veiculo.maxtagveiculo')}
                    label="nomemaxtagveiculo"
                    unique="maxtagveiculo"
                    url="modelosveiculosmaxtag"
                    params={{
                      fieldlist:
                        'idmodeloveiculo,nomemodelomarcamodeloveiculo,maxtagveiculomodelo',
                      orderfield: 'nomemodelomarcamodeloveiculo',
                      wherefield: 'idmodeloveiculo',
                      valuewherefield: snIdModeloVeiculo,
                      typewherefield: 'EQUALS',
                    }}
                    getValue={(value) => {
                      // handleModeloVeiculo(value);
                    }}
                    onLoadingChange={handleAsyncLoadingChange}
                    onLoadingError={handleAsyncLoadingError}
                  />
                )}

                {/* <Input
                  name="maxtagveiculo"
                  label={t('s.cadastro.veiculo.maxtagveiculo')}
                  disabled
                /> */}

                <Select
                  name="tipoveiculo"
                  label={t('s.cadastro.veiculo.tipoveiculo')}
                  options={[
                    { value: 0, label: t('s.cadastro.veiculo.proprio') },
                    { value: 1, label: t('s.cadastro.veiculo.terceiros') },
                    { value: 2, label: t('s.cadastro.veiculo.comboio') },
                  ]}
                  disabled={can(CUSTOMIZACAO_RAIZEN)}
                />

                {can(CUSTOMIZACAO_RAIZEN) && (
                  <Select
                    name="tipoauxiliarveiculo"
                    label={t('s.configuracao.comboio.tipoposto')}
                    options={[
                      {
                        value: 'V',
                        label: t('s.menu.cadastro.veiculo.veiculo'),
                      },
                      {
                        value: 'C',
                        label: t('s.menu.cadastro.veiculo.centrocusto'),
                      },
                    ]}
                    disabled={can(CUSTOMIZACAO_RAIZEN)}
                  />
                )}

                {can(CONTRATO_ABASTECIMENTO) && (
                  <Autocomplete
                    name="idcontrato"
                    label="nomecontratostr"
                    unique="idcontrato"
                    title={t('s.cadastro.veiculo.idcontrato')}
                    url="contratos"
                    onLoadingChange={handleAsyncLoadingChange}
                    onLoadingError={handleAsyncLoadingError}
                  />

                  // <Combobox
                  //   name="idcontrato"
                  //   label="nomecontratostr"
                  //   // label="nomecontrato"
                  //   url="contratos"
                  //   unique="idcontrato"
                  //   title={t('s.cadastro.veiculo.idcontrato')}
                  // />
                )}

                <Select
                  name="statusveiculo"
                  label={t('s.cadastro.veiculo.statusveiculo')}
                  options={[
                    { value: 'L', label: t('s.geral.opcoes.liberado') },
                    { value: 'B', label: t('s.geral.opcoes.bloqueado') },
                    { value: 'C', label: t('s.geral.opcoes.cancelado') },
                  ]}
                  disabled={can(CUSTOMIZACAO_RAIZEN)}
                />

                <Input
                  multiline
                  name="observacaoveiculo"
                  label={t('s.operacao.limpezatag.observacaohistoricotag')}
                  rows={4}
                />
              </Container>
            </ExpansionPanelDetails>

            <ExpansionPanelSummary
              aria-controls="panel2a-content"
              id="panel2a-header"
              style={{
                background: 'rgba(0, 0, 0, 0.05)',
                borderBottom: '1px solid rgba(0,0,0,.2)',
              }}
            >
              <Typography>{t('s.cadastro.veiculo.equipamentos')}</Typography>
            </ExpansionPanelSummary>
            <ExpansionPanelDetails>
              <Container>
                {!can(MODULO_CONSULTA_TOTALIZADOR) && (
                  <>
                    <Checkbox
                      name="possuidvecveiculo"
                      label={t('s.cadastro.veiculo.possuidvecveiculo')}
                      checked={initials.possuidvecveiculo === '1'}
                      getValue={(value) => {
                        setLeDEVEC(value);
                      }}
                      disabled={initials.iddvecveiculo}
                    />

                    {exibebloqueiadigitatotalizadordvecclienteconfig ===
                      'S' && (
                        <Checkbox
                          name="bloqueiadigitatotalizadordevecveiculo"
                          label={t(
                            's.cadastro.veiculo.bloqueiadigitatotalizadordevecveiculo'
                          )}
                          checked={
                            initials.bloqueiadigitatotalizadordevecveiculo === 'S'
                          }
                          disabled={!leDEVEC}
                          getValue={(value) => setBloqueiaTotDEVEC(value)}
                        />
                      )}
                  </>
                )}

                <Checkbox
                  name="possuittagveiculo"
                  label={t('s.cadastro.veiculo.possuittagveiculo')}
                  getValue={(value) => {
                    setLeituraC(value);
                    setPTTAG(value);
                  }}
                />

                {Number(formadigitacaofrota) === 1 && (
                  <Checkbox
                    name="digitafrotaterminalveiculo"
                    label={t('s.cadastro.veiculo.digitafrotaterminalveiculo')}
                    disabled={!leituraC}
                    getValue={(value) => setDFTV(value)}
                  />
                )}

                <Select
                  name="leituracontinuattagveiculo"
                  label={t('s.geral.nivelseguranca')}
                  options={[
                    { value: 0, label: t('s.geral.nivelseguranca.semleitura') },
                    { value: 1, label: t('s.geral.nivelseguranca.baixo') },
                    { value: 2, label: t('s.geral.nivelseguranca.medio') },
                    { value: 3, label: t('s.geral.nivelseguranca.alto') },
                  ]}
                  defaultValue={initials.leituracontinuattagveiculo || 0}
                />

                {can(MODULO_CONSULTA_TOTALIZADOR) && (
                  <Select
                    name="possuidvecveiculo"
                    label={t('labelsistema.leitortotalizadorveiculo')}
                    getValue={(value) =>
                      setSnPDVEC(includes(['2', '3', '4'], value))
                    }
                    options={[
                      { value: '0', label: t('labelsistema.naopossui') },
                      { value: '1', label: 'DVEC' },
                      { value: '2', label: 'Autotrac' },
                      { value: '3', label: 'SS Telemática' },
                      { value: '4', label: 'Solinftec' },
                    ]}
                    disabled={disablePossuiDvecPrenchidoEdit}
                  // disabled={initials.iddvecveiculo}
                  />
                )}

                <Input
                  name="iddvecveiculo"
                  label={
                    snPDVEC
                      ? t('labelsistema.codigoleitortotalizadorveiculo')
                      : t('s.cadastro.veiculo.iddvecveiculo')
                  }
                  disabled={disablePossuiDvecPrenchidoEdit}
                // disabled={!snPDVEC}
                />

                <ComboboxMultiple
                  name="transponders"
                  title={t('s.cadastro.veiculo.transponders')}
                  defaultValue={initials?.transponders || []}
                  disabled
                />
              </Container>
            </ExpansionPanelDetails>

            <ExpansionPanelSummary
              aria-controls="panel3a-content"
              id="panel3a-header"
              style={{
                background: 'rgba(0, 0, 0, 0.05)',
                borderBottom: '1px solid rgba(0,0,0,.2)',
              }}
            >
              <Typography>{t('s.cadastro.veiculo.autonomia')}</Typography>
            </ExpansionPanelSummary>
            <ExpansionPanelDetails>
              <Container>
                <Input
                  name="volumetanqueveiculo"
                  label={t('s.cadastro.veiculo.volumetanqueveiculo')}
                  type="number"
                  disabled={can(CUSTOMIZACAO_RAIZEN)}
                />
                {exibebloqtngveicclienteconfig === 'S' && (
                  <Select
                    name="bloqueiaabastacimatanqueveiculo"
                    label={t(
                      's.cadastro.veiculo.bloqueiaabastacimatanqueveiculo'
                    )}
                    options={status}
                  />
                )}

                <Input
                  name="rodagemminimaveiculo"
                  label={t('s.cadastro.veiculo.rodagemminimaveiculo')}
                  type="number"
                />
                <Input
                  name="rodagemmaximaveiculo"
                  label={t('s.cadastro.veiculo.rodagemmaximaveiculo')}
                  type="number"
                />
                {/* {JSON.stringify(tipoTotalizador)} */}
                <Select
                  name="tipototalizadorveiculo"
                  label={t('s.cadastro.veiculo.tipototalizadorveiculo')}
                  options={totalizador}
                  value={tipoTotalizador}
                  disabled={
                    initials.iddvecveiculo &&
                    initials.tipodvecveiculo > 0 &&
                    can(MODULO_AFERICAO_DVEC)
                  }
                  getValue={(value) => {
                    const newValue = Number(value); // Garantir que o valor de "0" seja tratado como número
                    setTipoTotalizador(newValue);
                    if (newValue === 0) {
                      setTipoTotalizador2(0);
                    }
                  }}
                />

                {Number(tipoTotalizador) > 0 && (
                  <>
                    <Select
                      name="digitostotalizadorveiculo"
                      label={t(
                        's.geral.camposistema.digitostotalizadorveiculo'
                      )}
                      options={totalizadorDigitosTotalizadorVeiculo}
                      disabled={
                        initials.iddvecveiculo &&
                        initials.tipodvecveiculo > 0 &&
                        can(MODULO_AFERICAO_DVEC)
                      }
                    />
                    <Select
                      name="casasdecimaistotalizadorveiculo"
                      label={t(
                        's.geral.camposistema.casasdecimaistotalizadorveiculo'
                      )}
                      options={totalizadorCasasDecimaisTotalizadorVeiculo}
                      disabled={
                        initials.iddvecveiculo &&
                        initials.tipodvecveiculo > 0 &&
                        can(MODULO_AFERICAO_DVEC)
                      }
                    />
                  </>
                )}

                {/* Verificando se tipoTotalizador2 é maior que 0 */}
                {tipoTotalizador === 0 && (
                  <>
                    <Hidden name="tipototalizador2veiculo" value="0" />
                    <Hidden name="digitostotalizador2veiculo" value="0" />
                    <Hidden name="casasdecimaistotalizador2veiculo" value="0" />
                  </>
                )}

                {tipoTotalizador > 0 && (
                  <>
                    <Select
                      name="tipototalizador2veiculo"
                      label={t('s.cadastro.veiculo.tipototalizador2veiculo')}
                      options={totalizador}
                      value={tipoTotalizador2}
                      getValue={(value) => setTipoTotalizador2(Number(value))}
                    />
                    {tipoTotalizador2 > 0 && (
                      <>
                        <Select
                          name="digitostotalizador2veiculo"
                          label={t(
                            's.cadastro.veiculo.digitostotalizador2veiculo'
                          )}
                          options={totalizadorDigitosTotalizadorVeiculo}
                        />
                        <Select
                          name="casasdecimaistotalizador2veiculo"
                          label={t(
                            's.cadastro.veiculo.casasdecimaistotalizador2veiculo'
                          )}
                          options={totalizadorCasasDecimaisTotalizadorVeiculo}
                        />
                      </>
                    )}
                  </>
                )}
                <Select
                  name="aceitatotforafaixa"
                  label={t('s.cadastro.veiculo.aceitatotforafaixa')}
                  options={status}
                />
              </Container>
            </ExpansionPanelDetails>

            <ExpansionPanelSummary
              aria-controls="panel4a-content"
              id="panel4a-header"
              style={{
                background: 'rgba(0, 0, 0, 0.05)',
                borderBottom: '1px solid rgba(0,0,0,.2)',
              }}
            >
              <Typography>
                {t('s.cadastro.veiculo.produtosabastecer')}
              </Typography>
            </ExpansionPanelSummary>
            <ExpansionPanelDetails>
              <Container>
                <ComboboxMultiple
                  name="produtos"
                  label="nomeproduto"
                  url="produtos"
                  unique="idproduto"
                  title={t('s.cadastro.veiculo.produtos')}
                  disabled={can(CUSTOMIZACAO_RAIZEN)}
                  params={{
                    wherefield: ['tipoproduto'],
                    typewherefield: ['EQUALS'],
                    valuewherefield: ['C'],
                    pesquisalista: ['true'],
                  }}
                  onLoadingChange={handleAsyncLoadingChange}
                  onLoadingError={handleAsyncLoadingError}
                />
              </Container>
            </ExpansionPanelDetails>

            {can(CONTROLE_DE_COTAS) && (
              <>
                <ExpansionPanelSummary
                  aria-controls="panel5a-content"
                  id="panel5a-header"
                  style={{
                    background: 'rgba(0, 0, 0, 0.05)',
                    borderBottom: '1px solid rgba(0,0,0,.2)',
                  }}
                >
                  <Typography>{t('s.cadastro.veiculo.cota')}</Typography>
                </ExpansionPanelSummary>

                <ExpansionPanelDetails>
                  <Container>
                    <Select
                      name="cota.controlacotaveiculocota"
                      label={t('s.cadastro.veiculo.controlacotaveiculocota')}
                      options={status}
                      defaultValue={
                        initials.cota
                          ? initials.cota.controlacotaveiculocota
                          : 'N'
                      }
                    />

                    <Input
                      name="cota.volumeveiculocota"
                      label={t('s.cadastro.veiculo.volumeveiculocota')}
                      type="number"
                      min="0"
                      defaultValue={
                        initials.cota ? initials.cota.volumeveiculocota : 0
                      }
                    />

                    <Input
                      name="cota.saldoveiculocota"
                      label={t('s.cadastro.veiculo.saldoveiculocota')}
                      type="number"
                      disabled
                    />
                  </Container>
                </ExpansionPanelDetails>
              </>
            )}

            {can(LUBRIFICACAO) && (
              <>
                <ExpansionPanelSummary
                  aria-controls="panel6a-content"
                  id="panel6a-header"
                  style={{
                    background: 'rgba(0, 0, 0, 0.05)',
                    borderBottom: '1px solid rgba(0,0,0,.2)',
                  }}
                >
                  <Typography>
                    {t('s.cadastro.modeloveiculo.compartimento')}
                  </Typography>
                </ExpansionPanelSummary>

                <ExpansionPanelDetails>
                  <Container>
                    <SelectDataInTable
                      icons={false}
                      create={false}
                      remove={false}
                      checkbox={false}
                      showPagination={false}
                      size="small"
                      variant="contained"
                      position="row"
                      onChanged={(value) =>
                        setCompartments(
                          value.map((v) => ({
                            ...v,
                            leituracontinuattagveiculocompartimento:
                              v.leituracontinuattagveiculocompartimento || 'N',
                            possuittagveiculocompartimento:
                              v.possuittagveiculocompartimento || 'N',
                          }))
                        )
                      }
                      unique="idcompartimento"
                      maxWidth="xs"
                      initials={
                        initials.veiculocompartimento || dataCompartments
                      }
                      fields={isFields}
                      schema={schemaValidate}
                      cells={cellsCompartiments}
                      titleModal={t('s.cadastro.modeloveiculo.compartimento')}
                    />
                  </Container>
                </ExpansionPanelDetails>
              </>
            )}

            {/* {JSON.stringify(initials.veiculocompartimento)} */}
            {/* {console.log(JSON.stringify(initials.veiculocompartimento))} */}

            {can(SAP) && (
              <>
                <ExpansionPanelSummary
                  aria-controls="panel6a-content"
                  id="panel6a-header"
                  style={{
                    background: 'rgba(0, 0, 0, 0.05)',
                    borderBottom: '1px solid rgba(0,0,0,.2)',
                  }}
                >
                  <Typography>{t('s.cadastro.modeloveiculo.sap')}</Typography>
                </ExpansionPanelSummary>

                <ExpansionPanelDetails>
                  <Container>
                    <Select
                      name="sap.movimentoveiculosap"
                      label={t('s.cadastro.veiculo.sap.movimentoveiculosap')}
                      options={tipomovimentaosap}
                      defaultValue={
                        initials.sap ? initials.sap.movimentoveiculosap : 201
                      }
                    />

                    <Input
                      name="sap.sigordemveiculosap"
                      label={t('s.cadastro.veiculo.sap.sigordemveiculosap')}
                      defaultValue={
                        initials.sap ? initials.sap.sigordemveiculosap : null
                      }
                      inputProps={{ maxLength: 20 }}
                    />

                    <Input
                      name="sap.elementopepveiculosap"
                      label={t('s.cadastro.veiculo.sap.elementopepveiculosap')}
                      defaultValue={
                        initials.sap ? initials.sap.elementopepveiculosap : null
                      }
                      inputProps={{ maxLength: 24 }}
                    />

                    <Input
                      name="sap.contarazaoveiculosap"
                      label={t('s.cadastro.veiculo.sap.contarazaoveiculosap')}
                      defaultValue={
                        initials.sap ? initials.sap.contarazaoveiculosap : null
                      }
                      inputProps={{ maxLength: 10 }}
                    />

                    <Input
                      name="sap.diagramaredeveiculosap"
                      label={t('s.cadastro.veiculo.sap.diagramaredeveiculosap')}
                      defaultValue={
                        initials.sap
                          ? initials.sap.diagramaredeveiculosap
                          : null
                      }
                      inputProps={{ maxLength: 12 }}
                    />

                    <Input
                      name="sap.reservaveiculosap"
                      label={t('s.cadastro.veiculo.sap.reservaveiculosap')}
                      defaultValue={
                        initials.sap ? initials.sap.reservaveiculosap : null
                      }
                      inputProps={{ maxLength: 10 }}
                    />

                    <Input
                      name="sap.equiptosapveiculosap"
                      label={t('s.cadastro.veiculo.sap.equiptosapveiculosap')}
                      defaultValue={
                        initials.sap ? initials.sap.equiptosapveiculosap : null
                      }
                      inputProps={{ maxLength: 18 }}
                    />

                    <Input
                      name="sap.frotasapveiculosap"
                      label={t('s.cadastro.veiculo.sap.frotasapveiculosap')}
                      defaultValue={
                        initials.sap ? initials.sap.frotasapveiculosap : null
                      }
                      inputProps={{ maxLength: 23 }}
                    />

                    <Input
                      name="sap.operacaoveiculosap"
                      label={t('s.cadastro.veiculo.sap.operacaoveiculosap')}
                      defaultValue={
                        initials.sap ? initials.sap.operacaoveiculosap : null
                      }
                      inputProps={{ maxLength: 4 }}
                    />
                  </Container>
                </ExpansionPanelDetails>
              </>
            )}

            {!can(CUSTOMIZACAO_RAIZEN) && (
              <ExpansionPanelDetails>
                <Container>
                  <CheckboxGroup
                    search
                    name="postos"
                    title={t('s.cadastro.veiculo.acessotodospostos')}
                    label="codigonomeposto"
                    unique="idposto"
                    url="postoscomboios"
                    getValue={(value) => {
                      setPostosVeiculo(value);
                    }}
                    query={{
                      filteruser: false,
                      wherefield: 'statusposto',
                      valuewherefield: 'L',
                      typewherefield: 'EQUALS',
                    }}
                    onLoadingChange={handleAsyncLoadingChange}
                    onLoadingError={handleAsyncLoadingError}
                  />
                </Container>
              </ExpansionPanelDetails>
            )}
          </ExpansionPanel>
        </Form>
      )}
    </>
  );
}

CreateOrUpdate.propTypes = {
  reference: PropTypes.objectOf(PropTypes.any).isRequired,
  create: PropTypes.bool.isRequired,
  data: PropTypes.objectOf(PropTypes.any),
  toggleLoading: PropTypes.func,
  toggleConfirmButton: PropTypes.func,
};

CreateOrUpdate.defaultProps = {
  data: {},
  toggleLoading: () => { },
  toggleConfirmButton: () => { },
};
